import { useState } from "react";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from "@mui/icons-material/Cancel";
import AttachFileIcon from '@mui/icons-material/AttachFile';

import ContractNewsForm, { NEWS_TYPES } from "./ContractNewsForm";
import currency from "currency.js";
import ContractNewsAttach from "./ContractNewsAttach";

const modalStyle = {
  bgcolor: "background.paper",
  boxShadow: 24,
  left: "50%",
  maxWidth: "980px",
  p: 4,
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%"
};

// `manualPaymentPlan` viaja tal cual hasta ContractNewsForm: es el modo de los
// contratos de persona jurídica (plan por hitos, sin recálculo automático).
const ContractNews = ({ contract, disabled, setNews, getContractFieldWithNews, manualPaymentPlan = false }) => {
  const [showNewsModal, setShowNewsModal] = useState(false);
  const [showAttachModal, setShowAttachModal] = useState(-1);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleAdd = () => {
    setShowNewsModal(true);
  };

  const handleDelete = (index) => {
    const updatedNews = contract.news.filter((_, idx) => idx !== index);
    setNews(updatedNews);
  };

  return (
    <>
      <Modal
        open={showNewsModal}
        onClose={() =>setShowNewsModal(false)}
      >
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ flex: 1 }}>Añadir novedad</Typography>
            <CloseIcon sx={{ cursor: 'pointer' }} onClick={() =>setShowNewsModal(false)} />
          </Box>

          <ContractNewsForm
            contract={contract}
            setNews={setNews}
            getContractFieldWithNews={getContractFieldWithNews}
            manualPaymentPlan={manualPaymentPlan}
            onSubmit={() => setShowNewsModal(false)}
          />
        </Box>
      </Modal>

      <Modal
        open={showAttachModal !== -1}
        onClose={() =>setShowAttachModal(-1)}
      >
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ flex: 1 }}>Añadir adjunto</Typography>
            <CloseIcon sx={{ cursor: 'pointer' }} onClick={() =>setShowAttachModal(-1)} />
          </Box>

          <ContractNewsAttach
            idx={showAttachModal}
            contract={contract}
            setNews={setNews}
            onSubmit={() => setShowAttachModal(-1)}
          />
        </Box>
      </Modal>

      <Box>
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ color: "gray", flex: 1 }}>Novedades</Typography>
          {!disabled
            && <IconButton onClick={handleAdd}>
              <AddCircleOutlineIcon />
            </IconButton>
          }
        </Box>
        {contract.news?.map((news, idx) => (
          <Box
            key={idx}
            onMouseEnter={() => setHoveredIndex(idx)}
            onMouseLeave={() => setHoveredIndex(null)}
            sx={{
              alignItems: "center",
              border: "thin solid #cccccc",
              borderRadius: 1,
              p: 1,
              my: 2,
              display: "flex",
              flexDirection: "row",
              position: "relative"
            }}>
            <Box sx={{ flex: 1 }}>
              {`N${idx + 1}.`} {NEWS_TYPES[news.type]}
            </Box>
            <Box sx={{ color: "gray", fontSize: "0.85em", textAlign: "right" }}>
              <Box>
                {news.startedAt.format("YYYY-MM-DD")}
                {news.finishedAt && ` - ${news.finishedAt.format("YYYY-MM-DD")}`}
              </Box>
              {news.description && <Box>{news.description}</Box>}
              {news.amount && <Box sx={{ color: "green", fontWeight: "bold" }}>{currency(news.amount, { precision: 0 }).format()}</Box>}
              {news.supervisor
                && <Box>
                  Nuevo supervisor: {news.supervisor.name} {news.supervisor.lastName}
                </Box>
              }
            </Box>
            <IconButton onClick={() => setShowAttachModal(idx)}>
              <AttachFileIcon />
            </IconButton>
            
            {hoveredIndex === idx && (
              <IconButton
                onClick={() => handleDelete(idx)}
                sx={{
                  position: 'absolute',
                  top: '-24px',
                  right: '-24px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#e09292ff'
                }}
              >
                <CancelIcon />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default ContractNews;
